module.exports = __webpack_public_path__ + "img/fa-solid-900.f4e2aa6a.svg";